<template>
  <div class="headerWarp">
    <div class="headerTime">
      <!-- <a-button @click="goHomeHandle"></a-button> -->
      <img @click="goHomeHandle" :src="isHomeHover ? homeImgHover : homeImg" @mouseenter="isHomeHover = true"
        @mouseleave="isHomeHover = false" />
      <span>{{ date | formatDate }}</span>
    </div>
    <div class="headerTitle">
      <img src="~@/assets/myImg/title-01.png" />
      <span class="DataTitle">大用户管理系统</span>
    </div>
    <div class="weatherWarp">
      <span>{{ alarme.text }} {{ alarme.temp }}°C 风向：{{ alarme.windDir }}</span>

      <img class="workImg" @click="goWorkTable" :src="isWorkHover ? workImgHover : workImg"
        @mouseenter="isWorkHover = true" @mouseleave="isWorkHover = false" />


      <img class="fullImg" @click="quanping" :src="'/iconImg/' + (isFullscreen ? 'h_h_min' : 'h_h_max') + '.png'" />
    </div>
  </div>
</template>
<script>
var padDate = function (value) {
  return value < 10 ? '0' + value : value
}
export default {
  name: 'NavigationBar',
  props: {
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      homeImg: require('@/assets/bigusers/largeScreen/homePage.png'),
      homeImgHover: require('@/assets/bigusers/largeScreen/homePageH.png'),
      isHomeHover: false,

      workImg: require('@/assets/bigusers/largeScreen/workTable.png'),
      workImgHover: require('@/assets/bigusers/largeScreen/workTableH.png'),
      isWorkHover: false,
      a: 0,
      date: new Date(),
      name: '',
      alarme: {
        temp: '',
        text: '',
        windDir: ''
      }
    }
  },
  filters: {
    formatDate: function (value) {
      var date = new Date(value)
      var year = date.getFullYear()
      var month = padDate(date.getMonth() + 1)
      var day = padDate(date.getDate())
      var hours = padDate(date.getHours())
      var minutes = padDate(date.getMinutes())
      var seconds = padDate(date.getSeconds())
      // 整理并返回
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    }
  },
  mounted: function () {
    var _this = this // 指向this 变量作用域一致;
    this.timer = setInterval(function () {
      _this.date = new Date() // 修改date
    }, 1000)
  },
  created () {
    this.name = this.$store.state.user.info.nickName
    this.getOnlineAlarme()
  },
  methods: {
    quanping () {
      console.log('按钮点击，当前全屏状态:', this.isFullscreen);
      // 使用自定义全屏方案
      this.$emit('toggle-custom-fullscreen');
    },
    getOnlineAlarme () {
      this.$http.get('/pipe-network/report/chart/get-weather').then(res => {
        this.alarme = res.data.now
      })
    },
    goHomeHandle () {
      this.$router.push('/')
    },
    goWorkTable () {
      this.$router.push('/bigusers/workbench/userControl/AllUserPage')
    }
  }
}
</script>

<style lang="less" scoped>
.headerWarp {
  width: 100%;
  height: 58px;
  opacity: 0.95;
  // background: rgba(6, 13, 42, 0.75);
  border-bottom: 2px solid rgba(16, 192, 255, 0.25);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  line-height: 58px;
  padding: 0 20px;
  box-sizing: border-box;

  .headerTime {
    font-family: MicrosoftYaHeiSemibold;
    font-size: 20px;
    color: #ffffff;
    font-weight: 600;
    display: flex;
    align-items: center;
    flex: 0 0 auto;

    img {
      height: 32px;
      width: 32px;
      cursor: pointer;
    }

    span {
      margin-left: 12px;
    }
  }

  .headerTitle {
    // z-index: 1000;
    position: relative;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 36px;
    color: #10c0ff;
    text-align: center;
    font-weight: 600;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .DataTitle {
      letter-spacing: 8px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0 auto;
      display: block;
      white-space: nowrap;
    }

    img {
      position: relative;
      z-index: 1000;
      max-width: 100%;
      height: 80px;
      width: auto;
    }
  }

  .workImg {
    width: 32px;
    height: 32px;
    margin-left: 30px;
    cursor: pointer;
  }

  .weatherWarp {
    flex: 0 0 auto;
    display: flex;
    align-items: center;

    span {
      font-family: MicrosoftYaHeiSemibold;
      font-size: 20px;
      color: #ffffff;
      display: inline-block;
      font-weight: 600;
    }

    .imgWeather {
      width: 18px;
      height: 18px;
      margin-right: 12px;
      // color: red;
      background-color: white;
    }

    .fullImg {
      width: 26px;
      height: 26px;
      margin-left: 12px;
      cursor: pointer;
    }
  }
}
</style>
